<template>
  <transition name="fade">
    <div v-if="!isCookieSet" class="cookie-banner">
      <slot name="content"></slot>
      <a href="/" class="close-cookie-banner" @click.prevent="closeBanner">
        <slot name="close"></slot>
      </a>
    </div>
  </transition>
</template>
<script>
import cookies from './cookies';

export default {
  name: 'cookiebanner',
  data: function () {
    return {
      isCookieSet: this.checkCookie(),
    };
  },
  created: function () {
    this.checkCookie();
  },
  methods: {
    closeBanner: function () {
      this.setCookie();
    },
    checkCookie: function () {
      const cookieRegExp = new RegExp(`${cookies.COOKIE_BANNER}=([^;]+)`);

      return Boolean(document.cookie.match(cookieRegExp));
    },
    setCookie: function () {
      const expireDate = new Date();

      expireDate.setDate(expireDate.getDate() + 90);
      document.cookie = `${cookies.COOKIE_BANNER} = true; expires="${expireDate.toUTCString()}";SameSite=Lax`;
      this.isCookieSet = true;
    },
  },
};
</script>
